// extracted by mini-css-extract-plugin
export var border = "_89-1";
export var hide = "_89-2";
export var input = "_89-0";
export var list = "_89-3";